import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import LOOKUP from 'constants/lookup';
import { discountListCrumb } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';
import { getCustomizedDiscounts, deleteCustomizedDiscount } from 'actions/EntityActions';
// Basic Components
import Button from 'screens/components/basic/Button';
import Grid from 'screens/components/basic/Grid';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';
// Advanced Components
import GenericTable from 'screens/components/advanced/GenericTable';
import DialogInputNew from 'screens/components/advanced/DialogInputNew';

class DiscountList extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            confirmDeleteDialog: false
        };
    }

    redirectToAddPage = () => {
        this.props.navigate("/manage/discount/add");
    }

    redirectToEditPage = (id) => {
        this.props.navigate(`/manage/discount/edit/${id}`);
    }

    openConfirmDeleteDialog = (itemId) => {
        this.setState({ confirmDeleteDialog: true, itemId });
    };

    closeConfirmDeleteDialog = () => {
        this.setState({ confirmDeleteDialog: false, itemId: "" });
    };

    confirmDeleteDiscount = (discountId) => {
        console.log(discountId);
        this.setState({ confirmDeleteDialog: false });
        this.props.deleteCustomizedDiscount(this.props.branchId, discountId);
    }

    componentDidMount() {
        this.props.getCustomizedDiscounts({
            branchId: this.props.branchId
        });
    }

    render() {
        const p = this.props;

        const tableRows = p.discounts.map(item => {
            return {
                Name: (<Link className="edit-link" to={`/manage/discount/edit/${item.id}`}>{item.name}</Link>),
                Type: (<span>{item.customizedDiscountType == 1 ? 'Percentage' : 'Amount'}</span>),
                Value: (<span>{item.customizedDiscountType == 1 ? `${item.value} %` : `$ ${item.value}`}</span>),
                Status: (item.status !== 1 ? <p className="statusIconRed m-0">InActive</p> :
                    <p className="statusIconGreen m-0">Active</p>),
                EditIcon: (
                    <Button
                        type="IconEditButton"
                        mini={true}
                        onTouchTap={() => this.redirectToEditPage(item.id)}
                    />
                ),
                DeleteIcon: (
                    <Button
                        mini={true}
                        type="IconDeleteButton"
                        className="glyphicon-remove-circle"
                        onTouchTap={() => this.openConfirmDeleteDialog(item.id)}
                    />
                )
            };
        });

        return (
            <Grid headerContent={discountListCrumb}>
                <PageHeaderWithButton title={LOOKUP.menu.manage.items.discount.text}>
                    <Button
                        type="AddButton"
                        mini={true}
                        className="bg-light-green"
                        label={LOOKUP.customizedDiscount.controls.addNewButton}
                        onTouchTap={() => this.redirectToAddPage()}
                    />
                </PageHeaderWithButton>
                <GenericTable
                    multiSelectable={false}
                    enableSelectAll={false}
                    selectable={false}
                    columns={LOOKUP.customizedDiscount.tableColumns}
                    rows={tableRows}
                    stripedRows={true}
                />
                <DialogInputNew
                    title="CONFIRM DELETE" 
                    handleClose={() => this.closeConfirmDeleteDialog()}
                    open={this.state.confirmDeleteDialog}
                    style={{ zIndex: "950" }}
                    actions={[
                        <Button
                            key={2}
                            name="ConfirmDelete"
                            label="Delete"
                            primary={true}
                            className="btn-space-20"
                            onTouchTap={() => this.confirmDeleteDiscount(this.state.itemId)}
                        />
                    ]}
                    contentStyle={{ width: "65%" }}
                >
                    <p className="purpleText">
                        Are you sure you wish to delete this discount?
                    </p>
                </DialogInputNew>
            </Grid>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        discounts: state.entity.customizedDiscounts || [],
        branchId: state.common.branchId
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getCustomizedDiscounts: (model) => dispatch(getCustomizedDiscounts(model)),
        deleteCustomizedDiscount: (branchId, discountId) => dispatch(deleteCustomizedDiscount(branchId, discountId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(DiscountList));